import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgUitvoeringWerkzaamheden = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FFBFA5"
      fillRule="evenodd"
      d="M16.65 8.71a5.67 5.67 0 0 1 1.48 5.45l7.71 7.71a5.67 5.67 0 0 1 6.92 6.92l-3.46-3.46-4 4 3.46 3.46a5.67 5.67 0 0 1-6.92-6.92l-7.71-7.71a5.67 5.67 0 0 1-6.92-6.92l3.46 3.46 4-4-3.46-3.46a5.67 5.67 0 0 1 5.44 1.47"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      d="M33.11 13.76 27.38 8a3.31 3.31 0 0 0-4.68 0l-1.1 1.1 2.77 2.78-16.7 16.73 3.73 3.74 16.71-16.71 1.56 1.56zM34.1 14.75l-.32-.33-3.44 3.44.32.33a.53.53 0 0 0 .74 0l2.7-2.7a.53.53 0 0 0 0-.74"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M23.007 6.876a3.84 3.84 0 0 1 5.426 0l-.706.708a2.84 2.84 0 0 0-4.014 0l-3.269 3.279-.708-.706 3.27-3.28M13.38 31.424l6.417-6.417.707.707-7.123 7.122-2.334-2.321.706-.71z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgUitvoeringWerkzaamheden);

export default ForwardRef;
